import Form from 'antd/lib/form'
import CustomDrawer from 'components/CustomDrawer'
import CustomSelect from 'components/CustomSelect'
import TextInput from 'components/CustomFormItem'
import AuthContext from 'contexts/AuthContext'
import { useContext } from 'react'

import {
  StyledContainer,
  StyledCompanyOptionContainer,
  StyledSwitchContainer,
  StyledSwitchLabel,
  StyledSwitch,
  StyledSelectContainer,
  StyledSwitchTitle,
} from './UserAddEditDrawer.styles'
import { TCompanyAddEditDrawer } from './UserAddEditDrawer.types'
import CustomSwitch from 'components/CustomSwitch/CustomSwitch'

const UserAddEditDrawer = ({
  open,
  closeDrawer,
  loading,
  handleSubmit,
  handleFormFieldChange,
  formData,
  companyUserChange,
  companyUser,
  options,
  handleCompanyChange,
  drawerType,
  form,
  isDirectlyAuthorised,
  handleDirectlyAuthorisedChange,
  handleCustomSelectChange,
}: TCompanyAddEditDrawer) => {
  const { user } = useContext(AuthContext)

  const accountTypeOptions = [
    { value: 'adviser', label: 'Adviser' },
    { value: 'lender', label: 'Lender' },
    { value: 'administrator', label: 'Administrator' },
    { value: 'solicitor', label: 'Solicitor' },
    { value: 'professional_third_party', label: 'Professional Third Party' },
    { value: 'later_life_lending_customer', label: 'Later Life Lending Customer' },
  ]

  return (
    <CustomDrawer
      loading={loading}
      open={open}
      closeDrawer={closeDrawer}
      title={drawerType === 'add' ? 'Add User' : 'Edit User'}
      disableSaveButton={false}
      handleSubmit={handleSubmit}
    >
      <StyledContainer>
        <Form
          form={form}
          layout="vertical"
          size="large"
          name="basic"
          onChange={handleFormFieldChange}
          initialValues={formData}
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: '12px',
          }}
        >
          <TextInput label="First Name  *" rules={['isRequired']} name="firstName" placeholder="First Name  *" />
          <TextInput label="Last Name  *" rules={['isRequired']} name="lastName" placeholder="Last Name  *" />
          <TextInput label="Email  *" name="email" placeholder="Email  *" rules={['isRequired', 'validateEmail']} />
          <TextInput label="Phone *" name="phoneNumber" placeholder="Phone *" rules={['isRequired']} />
          <TextInput label="Mobile Number" name="mobileNumber" placeholder="Mobile Number" />

          <div style={{ marginBottom: '12px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>Account Type *</label>
            <CustomSelect
              onChange={handleCustomSelectChange}
              defaultValue={formData.accountType}
              placeholder="Select Account Type"
              options={accountTypeOptions}
              width="100%"
            />
          </div>

          <div
            style={{
              width: '100%',
            }}
          >
            <StyledSwitchTitle>Are you directly authorised?</StyledSwitchTitle>
            <CustomSwitch checked={!!isDirectlyAuthorised} onChange={handleDirectlyAuthorisedChange} showYesNoLabels={true} />
          </div>

          {!isDirectlyAuthorised && (
            <TextInput label="Network Details *" name="networkDetails" type="textarea" placeholder="Enter network details" rules={['isRequired']} />
          )}

          <TextInput label="Iress Login ID" name="iressLoginId" placeholder="Enter Your Iress Login ID" />
          <TextInput label="Iress Password" name="iressPassword" placeholder="Enter Your Iress Password" />
          <TextInput label="Iress User ID" name="iressUserId" placeholder="Enter Your Iress User ID" type="number" />
          <TextInput label="FCA Number" name="fcaNumber" placeholder="Enter Your FCA Number" type="number" />
          {user.role === 'superAdmin' && (
            <StyledCompanyOptionContainer>
              <StyledSwitchContainer>
                <StyledSwitchLabel>Choose Another Company</StyledSwitchLabel>
                <StyledSwitch checked={companyUser} onChange={companyUserChange} />
              </StyledSwitchContainer>
              <StyledSelectContainer>
                <CustomSelect
                  disabled={!companyUser}
                  onChange={handleCompanyChange}
                  defaultValue={formData.companyId}
                  placeholder="Select Company"
                  options={options}
                  width="100%"
                  allowClear={false}
                />
              </StyledSelectContainer>
            </StyledCompanyOptionContainer>
          )}
        </Form>
      </StyledContainer>
    </CustomDrawer>
  )
}

export default UserAddEditDrawer
